var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader?{\"sourceMap\":false}!css-loader?{\"sourceMap\":false,\"minimize\":true,\"importLoaders\":1,\"alias\":{\"/assets\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\assets\",\"/static\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\static\"}}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-06cccb91\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./OrderInfo.vue")
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader?{\"sourceMap\":false}!css-loader?{\"sourceMap\":false,\"minimize\":true,\"importLoaders\":0,\"alias\":{\"/assets\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\assets\",\"/static\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\static\"}}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-06cccb91\",\"scoped\":false,\"hasInlineConfig\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./OrderInfo.vue")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[\"es2015\",\"stage-0\"],\"plugins\":[\"transform-runtime\"]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OrderInfo.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[\"es2015\",\"stage-0\"],\"plugins\":[\"transform-runtime\"]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OrderInfo.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-06cccb91\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"object\":\"src\",\"embed\":\"src\"},\"preserveWhitespace\":false,\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OrderInfo.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "components/Pages/customer/OrderInfo.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06cccb91", Component.options)
  } else {
    hotAPI.reload("data-v-06cccb91", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./components/Pages/customer/OrderInfo.vue
// module id = hSoi
// module chunks = 1 2